import Quiz from './Quiz'
import DetailsForm from './DetailsForm'
import QuizFinished from './QuizFinished';
import React from 'react'


export default function QuizesContent(
  {changeQuiz,
  activeQuiz,
  quizArray,
  completeQuiz,
  completedQuiz,
  frontpageObject,
  gap,
  handleChangeAnswers,
  checkedAnswers,
  scores,
  companyDetail,
  handleChangeTextarea}
){
  let quiz = quizArray.find((res) => {return res.id == activeQuiz } );
  return(
      <section className="section-questions">
      <div className="cont">
        <div className="tabs-container">

          <div className="tabs row">
            <button
            key={0}
            onClick={() => changeQuiz(0)}
            className={`tabs__button 
                ${activeQuiz == 0 ? 'active' : ''} 
                ${completedQuiz !== [] ? (0 in completedQuiz ? 'done' : '') : ''}
              `}

            >
              <span
                dangerouslySetInnerHTML={{__html: frontpageObject.acf.general_question.tab_text}}
              />
              <span
                dangerouslySetInnerHTML={{__html: frontpageObject.acf.general_question.mobile_tab_text}}
              />
              </button>
            {
              quizArray.map((res, i ) => (
                <React.Fragment key={i}>
                {
                  completedQuiz.length === 0
                  ? <button
                      key={res.id}
                      className={`tabs__button disabled`}
                    >
                      <span
                        dangerouslySetInnerHTML={{__html: res.acf.tab_title}}
                      />
                      <span
                        dangerouslySetInnerHTML={{__html: res.acf.small_tab_title}}
                      />
                    </button>
                  : <button
                      key={res.id}
                      onClick={() => changeQuiz(res.id)}

                      className={`tabs__button 
                        ${activeQuiz == res.id ? 'active' : ''} 
                        ${completedQuiz['answer_' + res.id] != undefined ? (completedQuiz['answer_' + res.id].status == true  ? 'done' : '') : ''}
                      `}
                    >
                      <span
                        dangerouslySetInnerHTML={{__html: res.acf.tab_title}}
                      />
                      <span
                        dangerouslySetInnerHTML={{__html: res.acf.small_tab_title}}
                      />
                    </button>
                }



                </React.Fragment>
              ))
            }
          </div>

          {

            quiz != undefined && gap === false
            ? <Quiz
                quiz={quiz}
                completeQuiz={completeQuiz}
                scores={scores}
                checkedAnswers={checkedAnswers}
                frontpageObject={frontpageObject}
                handleChangeAnswers={handleChangeAnswers}
                completedQuiz={completedQuiz}
                quizLen={Object.keys(quizArray).length}
              />
            : gap === false ? <DetailsForm
                companyDetail={companyDetail}
                handleChangeTextarea={handleChangeTextarea}
                frontpageObject={frontpageObject}
                completeQuiz={completeQuiz}
              />
              : ''
          }


          {                
            gap === true ? <QuizFinished object={frontpageObject} completeQuiz={completeQuiz} quiz={quiz} /> : ''
          }

        </div>
      </div>
    </section>
    )
      }